import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RfAuthenticationService } from 'src/app/authentication/rf-authentication.service';
import { MobileComponent } from 'src/app/shared/components/mobile/interface/mobile.component';
import { ProfileService } from '../../service/profile.service';
import { HeadingWidgetComponent } from 'src/app/shared/components/heading-widget/heading-widget.component';
import { MaterialModule } from 'src/app/shared/module/material.module';
import { ReadMoreComponent } from 'src/app/shared/components/read-more/read-more.component';
import { I18nPipe } from 'src/app/shared/i18n/pipe/i18n.pipe';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'ald-connect-user',
    templateUrl: './connect-user.component.html',
    styleUrls: ['./connect-user.component.scss'],
    imports: [
        HeadingWidgetComponent,
        MaterialModule,
        ReadMoreComponent,
        I18nPipe
    ]
})
export class ConnectUserComponent
  extends MobileComponent
  implements OnInit, OnDestroy {

  constructor(
    public dialogRef: MatDialogRef<ConnectUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private profileService: ProfileService,
    private rfAuthenticationService: RfAuthenticationService) {
    super();
  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

  close() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.profileService.connectUser().subscribe(() => this.rfAuthenticationService.logout())
  }

}
